export * from "./toTelephoneString";
